import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import { ValidationService } from 'src/app/common/services/validation.service';

export interface StandardReport {
  paragraph: string;
  sequence: string;
  topic: string;
}

export interface CodificationReport {
  standardtype: string;
  standardnumber: string;
  paragraph: string;
  sequence: string;
  paragraphid: string;
}

export interface CrossReferenceReport {
  standard: any;
  codification:any;
  SearchCriteria: string;
}
@Component({
  selector: 'app-cross-reference',
  templateUrl: './cross-reference.component.html',
  styleUrls: ['./cross-reference.component.css']
})

export class CrossReferenceComponent implements OnInit {

  Standard_form_enable: boolean = false;
  Codification_form_enable: boolean = false;

  SearchSection: string = "";
  cr_header: string;
  cr_subtitle: string;
  cr_info: string;
  cr_byStandard: string;
  cr_standardType: string;
  cr_year: string;
  cr_number: string;

  cr_byCodification: string;
  cr_topic: string;
  cr_Subtopic: string;
  cr_section: string;
  cr_paragraph: string;

  cr_startOver: string;
  cr_generate: string;

  cr_paragraphLabel: string;
  cr_sequence: string;
  cr_topicSubtopicSubsectionParagraph: string;
  cr_accordion1: string;
  cr_accordion2: string;
  cr_links: any;
  cr_quickReferenceSubtext: string;
  cr_standard_dropdown: Map<any, any>;
  cr_standard_number: string;
  cr_paragraph_within: string;
  cr_paragraphid: string;
  cr_report_title: string;

  showPage: boolean = false;

  CodificationForm: FormGroup;
  StandardForm: FormGroup;
  Modified_CodificationForm: FormGroup;
  Modified_StandardForm: FormGroup;
  StandardReport_title: string;
  CodificationReport_title: string;

  generate_btn_enable: boolean = false;
  start_over_btn_enable: boolean = false;

  panelOpenState: boolean = false;
  generateReport: boolean = false;
  public dataSource_standard_glossaryTerms = new MatTableDataSource<any>();
  public dataSource_standard_paragraph = new MatTableDataSource<any>();
  columnDetails: any;
  SortActiveColumn: any;

  standard_year_dropdown_disable: boolean = true;
  cr_standard_year_dropdown: Map<any, any>;

  ReportSearchCriteria: CrossReferenceReport;
  DataSourceAvailable: boolean = false;

  formvalidationError: string = "";

  standardtype_list: string[] = [];
  standard_type_number_list: string[] = [];
  standardtype_year_list: string[] = [];

  CodificationFormValues: number = 0;
  CodificationFormValid: boolean = false;

  radioStandard: boolean = false
  radioCodification: boolean = false
  TopicValue;
  SubtopicValue;
  SectionValue;
  ParagraphValue;
  standardDropdown:any=[];
  @ViewChild('standardTypeDropdown', { static: false }) standardTypeDropdown: MatSelect
  @ViewChild('standardNumberDropdown', { static: false }) standardNumberDropdown: MatSelect
  @ViewChild('standardYearDropdown', { static: false }) standardYearDropdown: MatSelect

  constructor(private _validationService: ValidationService, private graphQlService: GraphqlService, private formBuilder: FormBuilder, private openlink: OpenLinkById, private sanitizer: DomSanitizer, private commonDataService: CommonDataService) { }

  ngOnInit(): void {
    //this.commonDataService.printOptions.next("");
    //this.commonDataService.displayOptions.next("");

    this.getStandardType();
    this.initializeForms();

    this.StandardForm.disable();
    this.CodificationForm.disable();
   
    this.getCrossReferenceLabels();
    this.commonDataService.showLoader.next(false);
  }
  
  getStandardType(){
    this.graphQlService.GetCrossRefStandardType().subscribe(type=>{
      if(type){
        this.standardtype_list=[];
        this.standardDropdown=type?.aggregations?.standardTypes?.buckets;
        this.standardDropdown.forEach(element => {
          this.standardtype_list.push(element.key);
        });
        localStorage.setItem("CrossRefStandardTypeDropdown",JSON.stringify(this.standardDropdown));
        this.getStandardYear();
      }
    })
  }

  getCrossReferenceLabels(){
    this.graphQlService.getCrossReferenceLabel().subscribe(data => {
      if (data != "") {
        var labels = data.item1;
        labels = labels.filter(x => x.key.trim());
        this.cr_header = labels.filter(x => x.key == "cr_header").map(y => y.value);
        this.cr_subtitle = labels.filter(x => x.key == "cr_subtitle").map(y => y.value);
        this.cr_info = labels.filter(x => x.key == "cr_info").map(y => y.value);
        this.cr_byStandard = labels.filter(x => x.key == "cr_byStandard").map(y => y.value);
        this.cr_standardType = labels.filter(x => x.key == "cr_standardType").map(y => y.value);
        this.cr_year = labels.filter(x => x.key == "cr_year").map(y => y.value);
        this.cr_number = labels.filter(x => x.key == "cr_number").map(y => y.value);

        this.cr_byCodification = labels.filter(x => x.key == "cr_byCodification").map(y => y.value);
        this.cr_topic = labels.filter(x => x.key == "cr_topic").map(y => y.value);
        this.cr_Subtopic = labels.filter(x => x.key == "cr_Subtopic").map(y => y.value);
        this.cr_paragraph = labels.filter(x => x.key == "cr_paragraph").map(y => y.value);
        this.cr_section = labels.filter(x => x.key == "cr_section").map(y => y.value);

        this.cr_startOver = labels.filter(x => x.key == "cr_startOver").map(y => y.value);
        this.cr_generate = labels.filter(x => x.key == "cr_generate").map(y => y.value);

        this.cr_paragraphLabel = labels.filter(x => x.key == "cr_paragraphLabel").map(y => y.value);
        this.cr_sequence = labels.filter(x => x.key == "cr_sequence").map(y => y.value);
        this.cr_topicSubtopicSubsectionParagraph = labels.filter(x => x.key == "cr_topicSubtopicSubsectionParagraph").map(y => y.value);

        this.cr_accordion1 = labels.filter(x => x.key == "cr_accordion1").map(y => y.value);
        this.cr_accordion2 = labels.filter(x => x.key == "cr_accordion2").map(y => y.value);
        this.cr_links = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "cr_links").map(y => y.value));
        this.cr_quickReferenceSubtext = labels.filter(x => x.key == "cr_quickReferenceSubtext").map(y => y.value);
        this.cr_standard_number = labels.filter(x => x.key == "cr_standard_number").map(y => y.value);
        this.cr_paragraph_within = labels.filter(x => x.key == "cr_paragraph_within").map(y => y.value);
        this.cr_report_title = labels.filter(x => x.key == "cr_report_title").map(y => y.value);

        // this.cr_standard_dropdown=new Map(Object.entries(data.item2));
        // this.cr_standard_year_dropdown=new Map(Object.entries(data.item3));
        this.showPage=true;

        // this.standardtype_list=Array.from(this.cr_standard_dropdown.keys());
          this.LoadCrossRefBackfromContenPage()
      }
    });
  }

  initializeForms() {
    this.StandardForm = this.formBuilder.group({
      StandardType: [''],
      Year: [''],
      Number: ['']
    });

    this.CodificationForm = this.formBuilder.group({
      Topic: [''],
      Subtopic: [''],
      Section: [''],
      Paragraph: ['']
    });

  }
  StartOver() {
    this.CodificationForm.reset({});
    this.StandardForm.reset({})
    localStorage.removeItem("crossReference");
    localStorage.removeItem("CrossRefStandardTypeDropdown");
    this.DataSourceAvailable=false;
  }
  onCodificationInputChange(event) {
    var value = event.target.value;

    if (value != "") {
      this.CodificationFormValid = true;
    }
    else {
      if (this.CodificationForm.controls['Topic'].value != '' || this.CodificationForm.controls['Subtopic'].value != '' || this.CodificationForm.controls['Section'].value != '' || this.CodificationForm.controls['Paragraph'].value != '') {
        this.CodificationFormValid = true;
      }
      else {
        this.CodificationFormValid = false;
        this.generateReport = false;
        this.formvalidationError = "";

        this.CodificationForm.controls['Topic'].markAsUntouched();
        this.CodificationForm.controls['Subtopic'].markAsUntouched();
        this.CodificationForm.controls['Section'].markAsUntouched();
        this.CodificationForm.controls['Paragraph'].markAsUntouched();
      }
    }
    if (document.getElementById("generateButton")) {
      document.getElementById("generateButton").focus();
    }
  }

  onSearchOptionChange(searchoption: string) {
    var Standard_div = document.getElementById("Standard");
    var Codification_div = document.getElementById("Codification");

    if (searchoption == "Standard") {
      this.StandardForm.enable();
      this.CodificationForm.disable();

      this.Standard_form_enable = true;
      this.Codification_form_enable = false;
      this.generateReport = false;
      this.standard_year_dropdown_disable = false;
      this.formvalidationError="";

      Standard_div.className += " search_area_highlight";
      Codification_div.classList.remove("search_area_highlight");
    }
    else
    {
      this.CodificationForm.enable();
      this.StandardForm.disable();

      this.Codification_form_enable = true;
      this.Standard_form_enable = false;
      this.generateReport = false;

      Codification_div.className += " search_area_highlight";
      Standard_div.classList.remove("search_area_highlight");
      this.enableButton=false;
    }

  }

  LoadCrossRefBackfromContenPage() {
    var res = this.commonDataService.backbuttoncrossreference.getValue();
    if (res) {
    this.initializeForms();
    this.standardDropdown=JSON.parse(localStorage.getItem("CrossRefStandardTypeDropdown"));
    this.getStandardYear();
    if (this.standardDropdown.length > 0){
    let data = JSON.parse(localStorage.getItem("crossReference"));
    var searchoption = data.CodificationForm.Topic == null ? "Standard" : "Codification"
    this.generateReport = true;

    if (searchoption == "Standard") {
      this.radioStandard = true;
      this.StandardForm.enable();
      this.CodificationForm.disable();
      this.Standard_form_enable = true;
      this.Codification_form_enable = false;
      this.standard_year_dropdown_disable = true;
      this.StandardForm.controls["StandardType"].enable()
      this.StandardForm.controls["StandardType"].markAsDirty()

      var standardNumber = this.standardDropdown.filter(x => x.key == data.StandardForm.StandardType)[0].standardNumbers.buckets;
      if (standardNumber) {
        this.standard_type_number_list = [];
        standardNumber.forEach(number => {
          this.standard_type_number_list.push(number.key);
        })
      }
      if(data.StandardForm.StandardType=='ASU'){
        this.standard_year_dropdown_disable = false;
        this.standardtype_year_list = [];
        this.standard_type_number_list = [];
        this.standardtype_year_list = this.standard_year.map(x => x.year);
  
        this.standard_type_number_list = this.standard_year.filter(x => x.year == data.StandardForm.Year).map(x => x.number)[0];
      }
      // this.standard_type_number_list = this.cr_standard_dropdown.get(data.StandardForm.StandardType);
      this.StandardForm.patchValue({
        StandardType: data.StandardForm.StandardType,
        Year: data.StandardForm.Year,
        Number: data.StandardForm.Number
      });
    }
    else {
      this.CodificationForm.enable();
      this.radioCodification = true;
      this.Codification_form_enable = true;
      this.CodificationFormValid = true;
      this.Standard_form_enable = false;

      this.StandardForm.disable();
      this.CodificationForm.patchValue({
        Topic: data.CodificationForm.Topic,
        Subtopic: data.CodificationForm.Subtopic,
        Section: data.CodificationForm.Section,
        Paragraph: data.CodificationForm.Paragraph
      });

      this.TopicValue = data.CodificationForm.Topic
      this.SubtopicValue = data.CodificationForm.Subtopic
      this.SectionValue = data.CodificationForm.Section
      this.ParagraphValue = data.CodificationForm.Paragraph
      // this.CodificationForm.controls['Topic'].markAsDirty();
      // this.CodificationForm.controls['Subtopic'].markAsDirty();
      // this.CodificationForm.controls['Section'].markAsDirty();
      // this.CodificationForm.controls['Paragraph'].markAsDirty();
    }
    this.GenerateCFReport(data.CodificationForm, data.StandardForm);
    this.commonDataService.backbuttoncrossreference.next(false);
  }
     }
  }
  GenerateCFReport(CodificationForm, StandardForm) {
    let crossRef = {
      CodificationForm: CodificationForm,
      StandardForm: StandardForm
    }
    localStorage.setItem("crossReference", JSON.stringify(crossRef))
    this.generateReport = false;
    this.DataSourceAvailable = false;
    this.cr_paragraphid = "";
    this.CodificationReport_title = "";

    this.formvalidationError = "";

    if (this.StandardForm.value["StandardType"] != 'ASU') {
      this.StandardForm.value["Year"] = "";
    }

    this.Modified_CodificationForm = CodificationForm;
    this.Modified_StandardForm = StandardForm;

    if (StandardForm?.StandardType != null && StandardForm?.StandardType != undefined && StandardForm?.StandardType != "") {
      this.SearchSection = "Standard";
      this.commonDataService.currentSortHeaderSTT.next(this.SearchSection);
      this.StandardReport_title = this.StandardForm.value["StandardType"] + " " + (this.StandardForm.value["Year"] == "" ? "" : (this.StandardForm.value["Year"] + " - ")) + this.StandardForm.value["Number"];
      this.ReportSearchCriteria = {
        standard: StandardForm,
        codification: CodificationForm, SearchCriteria: "standard"
      };
      this.SortActiveColumn = "paragraph";
      this.columnDetails = [
        { columnDef: 'standardType', sortHeader: 'no', header: this.cr_standardType, cell: (element: any) => `${element.standardType}` },
        { columnDef: 'standardNumber', sortHeader: 'no', header: this.cr_standard_number, cell: (element: any) => `${element.standardNumber}` },
        { columnDef: 'paragraph', sortHeader: 'yes', header: this.cr_paragraphLabel, cell: (element: any) => `${element.paragraph}` },
        // { columnDef: 'sequence',sortHeader:'no', header: this.cr_sequence, cell: (element: any) => `${element.sequence}` },
        { columnDef: 'topic', sortHeader: 'yes', header: this.cr_topicSubtopicSubsectionParagraph, cell: (element: any) => `${element.topic}` },
      ];
      this.getCrossReferenceReport(this.ReportSearchCriteria);

    }
    else {
      this.SearchSection = "Codification";
      this.commonDataService.currentSortHeaderSTT.next(this.SearchSection);
      if (CodificationForm.Topic != null && CodificationForm.Topic != undefined && CodificationForm.Topic != "") {
        this.CodificationReport_title = this.CodificationForm.controls['Topic'].value;
      }

      if (CodificationForm.Subtopic != null && CodificationForm.Subtopic != undefined && CodificationForm.Subtopic != "") {

        if (!this._validationService.validateRequiredField(this.CodificationForm.controls['Topic'].value)) {
          this.CodificationForm.controls['Topic'].setErrors({ 'required': true });
          this.formvalidationError = this._validationService.getErrorMessage('required', this.cr_topic, null)
          this.CodificationForm.controls['Topic'].markAsTouched();
        }
        if (this.CodificationForm.controls['Topic'].value != '' && this.CodificationForm.controls['Subtopic'].value != '') {
          this.CodificationReport_title = this.CodificationReport_title + " - " + this.CodificationForm.controls['Subtopic'].value;
        }

      }
      if (CodificationForm.Section != null && CodificationForm.Section != undefined && CodificationForm.Section != "") {
        if ((this.CodificationForm.controls['Topic'].value == '' && this.CodificationForm.controls['Subtopic'].value == '') || (this.CodificationForm.controls['Topic'].value == null && this.CodificationForm.controls['Subtopic'].value == null)) {
          this.CodificationForm.controls['Topic'].setErrors({ 'required': true });
          this.CodificationForm.controls['Topic'].markAsTouched();

          this.CodificationForm.controls['Subtopic'].setErrors({ 'required': true });
          this.CodificationForm.controls['Subtopic'].markAsTouched();

          this.formvalidationError = this._validationService.getErrorMessage('required', this.cr_topic + " or " + this.cr_Subtopic, null)
        }
        else if (this.CodificationForm.controls['Topic'].value != '' && this.CodificationForm.controls['Subtopic'].value == '') {
          this.formvalidationError = "";
        }

        if (this.CodificationForm.controls['Topic'].value != '' && this.CodificationForm.controls['Subtopic'].value != '' && this.CodificationForm.controls['Section'].value != '') {
          this.CodificationReport_title = this.CodificationReport_title + " - " + this.CodificationForm.controls['Section'].value;
        }
      }
      if (CodificationForm.Paragraph != null && CodificationForm.Paragraph != undefined && CodificationForm.Paragraph != "") {

        if (!this._validationService.validateRequiredField(this.CodificationForm.controls['Section'].value)) {
          this.CodificationForm.controls['Section'].setErrors({ 'required': true });
          this.formvalidationError = this._validationService.getErrorMessage('required', this.cr_section, null)
          this.CodificationForm.controls['Section'].markAsTouched();
        }
        if (this.CodificationForm.controls['Topic'].value != '' && this.CodificationForm.controls['Subtopic'].value != '' && this.CodificationForm.controls['Section'].value != '') {
          this.CodificationReport_title = this.CodificationReport_title + " - " + this.CodificationForm.controls['Paragraph'].value;
        }
      }

      if (this.formvalidationError == "") {

        this.CodificationForm.controls['Topic'].markAsUntouched();
        this.CodificationForm.controls['Subtopic'].markAsUntouched();
        this.CodificationForm.controls['Section'].markAsUntouched();
        this.CodificationForm.controls['Paragraph'].markAsUntouched();


        this.ReportSearchCriteria = { standard: StandardForm, codification: CodificationForm, SearchCriteria: "Codification" };
        this.SortActiveColumn = "standardType";
        this.cr_paragraphid = this.cr_paragraph_within + " " + this.CodificationReport_title;
        this.columnDetails = [
          { columnDef: 'standardType', sortHeader: 'yes', header: this.cr_standardType, cell: (element: any) => `${element.standardType}` },
          { columnDef: 'standardNumber', sortHeader: 'no', header: this.cr_standard_number, cell: (element: any) => `${element.standardNumber}` },
          { columnDef: 'paragraph', sortHeader: 'no', header: this.cr_paragraphLabel, cell: (element: any) => `${element.paragraph}` },
          // { columnDef: 'sequence',sortHeader:'no', header: this.cr_sequence, cell: (element: any) => `${element.sequence}` },
          { columnDef: 'paragraphId', sortHeader: 'yes', header: this.cr_paragraphid, cell: (element: any) => `${element.paragraphId}` },
        ];
        this.getCrossReferenceReport(this.ReportSearchCriteria);
      }


    }

  }
  getCrossReferenceReport(searchData: CrossReferenceReport) {
    this.graphQlService.getElasticCrossReferenceReport(this.ReportSearchCriteria).subscribe(data => {
      if (data != null) {
        this.dataSource_standard_paragraph.data = data.item1 as unknown as any[];
        this.dataSource_standard_glossaryTerms.data = data.item2 as unknown as any[];
        this.DataSourceAvailable = true;
        this.generateReport = true;
      }
      if (this.StandardForm.controls.StandardType.value != null && this.StandardForm.controls.Number.value != null) {
        localStorage.setItem('cross_reference_standardType', this.StandardForm.controls.StandardType.value);
        localStorage.setItem('cross_reference_standardNumber', this.StandardForm.controls.Number.value);
      }
      else {
        localStorage.setItem('cross_reference_standardType', '');
        localStorage.setItem('cross_reference_standardNumber', '');
      }
      
    });
  }

  standard_year:any=[];
  getStandardYear(){
    this.standard_year=[];
    var year_buckets=this.standardDropdown.filter(x=>x.key=='ASU')[0].standardNumbers.buckets;
    year_buckets.forEach(year_res=>{
      if(year_res && !year_res.key.toLowerCase().includes("plm")){
        let key=year_res.key.split('-');
        if(this.standard_year && this.standard_year.length==0){
          let obj={
            year:key[0],
            number:[key[1]]
          }
          this.standard_year.push(obj);
        }
        else{
          var yearExists=this.standard_year.filter(x=>x.year==key[0]);
          if(yearExists.length>0){
            this.standard_year.filter(x=>x.year==key[0])[0].number.push(key[1]);
          }
          else{
            let obj={
              year:key[0],
              number:[key[1]]
            }
            this.standard_year.push(obj);
          }
        }
       
      }
    })
  }
  enableButton: boolean = false;
  onStandardTypeChange(event){
    this.standard_year_dropdown_disable=true;
    this.StandardForm.get('Year').setValue('');

    var standardNumber = this.standardDropdown.filter(x => x.key == this.StandardForm.value['StandardType'])[0].standardNumbers.buckets;
    if (standardNumber) {
      this.standard_type_number_list = [];
      standardNumber.forEach(number => {
        this.standard_type_number_list.push(number.key);
        this.StandardForm.get('Number').setValue(this.standard_type_number_list[0]);
      })
    }
    if (event.value == 'ASU') {
      this.standard_year_dropdown_disable = false;
      this.standardtype_year_list = [];
      this.standard_type_number_list = [];
      this.standardtype_year_list = this.standard_year.map(x => x.year);
      this.StandardForm.get('Year').setValue(this.standard_year.map(x => x.year)[0]);

      this.standard_type_number_list = this.standard_year.filter(x => x.year == this.standard_year.map(y => y.year)[0]).map(z => z.number)[0];
      this.StandardForm.get('Number').setValue(this.standard_type_number_list[0]);
    }
    if (this.standardTypeDropdown) {
      this.standardTypeDropdown.close();
    }
    this.enableButton = true;
    const generateButton = document.getElementById("generateButton");
    if (generateButton) {
      generateButton.focus();
    }
  }
  
  onStandardYearChange(event){
    this.standard_type_number_list=this.standard_year.filter(x=>x.year==event.value).map(x=>x.number)[0];
    this.StandardForm.get('Number').setValue(this.standard_type_number_list[0]);
    this.standardYearDropdown.close();
    document.getElementById("generateButton").focus();
  }

  onStandardNumberChange(){
    this.standardNumberDropdown.close();
    document.getElementById("generateButton").focus();
  }

  openLinkById(event) {
    this.openlink.openLinkById(event);
  }

  gotoSection() {
    document.getElementById('scrollToTop').scrollIntoView();
  }

  setFocus(event) {
    this.standardTypeDropdown.close();
    event.preventDefault();
    document.getElementById("generateButton").focus()
  }
  mouseUp() {
    document.getElementById("generateButton").focus()
  }
}
